import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    text: _ctx._tooltip,
    location: "top"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        color: _ctx.value_ ? _ctx.highlightColor_ : '',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.value_ = true)),
        icon: _ctx._icon,
        variant: "plain",
        class: _ctx._buttonClass
      }), null, 16, ["color", "icon", "class"])
    ]),
    _: 1
  }, 8, ["text"]))
}